"use client";
import {
  ButtonComponent,
  ModalComponent,
  TextFieldComponent,
} from "@/components";
import { IMAGES, WEB_COLORS, WEB_EVENTS } from "@/lib/constants";
import useErrorHandling from "@/lib/hooks/errorhandling";
import { sendUnserviceableEventAnalytics } from "@/lib/hooks/eventAnalytics";
import useLogoutHook from "@/lib/hooks/logoutHook";
import { useCheckServicedPincodeMutation } from "@/lib/redux";
import { Stack, Typography } from "@mui/material";
import { useFormik } from "formik";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { useState } from "react";
import * as Yup from "yup";

const PincodeValidation = ({ open, setOpen, route }) => {
  const t = useTranslations("Pincodevalidation");
  const { handleLogout } = useLogoutHook();
  const [checkPincode, { data, error }] =
    useCheckServicedPincodeMutation();
  const [openModal, setOpenModal] = useState(false);
  const formik = useFormik({
    initialValues: {
      pincode: "",
    },
    validationSchema: Yup.object().shape({
      pincode: Yup.string()
        .required("Pincode is required")
        .matches(/^[0-9]{6}$/, "Pincode should be 6 digits"),
    }),
    onSubmit: (values) => {
      checkPincode(values).then((response) => {
        switch (response?.data?.data?.pinServiceable) {
          case "redirect":
            sendUnserviceableEventAnalytics({
              eventName: WEB_EVENTS.PIN_UNSERVICEABLE,
              pin: formik.values.pincode,
            });
            handleLogout();
            window.location.href =
              "https://www.herofincorp.com/instant-personal-loan/login";
            break;
          case "block":
            sendUnserviceableEventAnalytics({
              eventName: WEB_EVENTS.PIN_UNSERVICEABLE,
              pin: formik.values.pincode,
            });
            setOpenModal(true);
            break;
          default:
            route();
        }
      });
    },
  });
  const handleFieldChange = (e, regex) => {
    if (regex.test(e.target.value)) {
      formik.handleChange(e);
    }
  };

  const modalContent = () => {
    const servicedPin = data?.data?.pinServiceable;
    if (!servicedPin) return;
    switch (servicedPin) {
      case "block":
        return (
          <Stack rowGap={2} flexDirection={"column"} alignItems={"center"}>
            <Image src={IMAGES.noService} alt="no service" />
            <Typography
              color={WEB_COLORS.darkTeal}
              fontWeight={700}
              fontSize={{ md: "24px", xs: "16px" }}
              align="center"
            >
              We're Sorry! Currently, we are not servicing your area
            </Typography>
            <Typography variant="body1" align="center">
              {t("notserviceable")}
            </Typography>
            <ButtonComponent
              onClick={() => {
                handleLogout();
              }}
            >
              {t("ok")}
            </ButtonComponent>
          </Stack>
        );
      default:
        return;
    }
  };

  useErrorHandling(error);

  return (
    <>
      <ModalComponent
        open={open}
        title={t("verify")}
        closeButtonRequired={false}
        handleModal={setOpen}
      >
        <Stack rowGap={2}>
          <Typography variant="h4" align="center">
            {t("hero")}
          </Typography>
          <Typography variant="body1" align="center">
            {t("enterpin")}
          </Typography>
          <TextFieldComponent
            maxLength={6}
            name="pincode"
            value={formik.values.pincode}
            label={t("pincode")}
            placeholder={t("enterpin")}
            onChange={(e) => {
              handleFieldChange(e, /^[0-9]{0,6}$/);
            }}
            onBlur={formik.handleBlur}
            error={formik.touched.pincode && Boolean(formik.errors.pincode)}
            errorMessage={formik.touched.pincode && formik.errors.pincode}
          />
          <ButtonComponent
            type="submit"
            onClick={() => {
              formik.handleSubmit();
            }}
          >
            {t("submit")}
          </ButtonComponent>
        </Stack>
      </ModalComponent>
      <ModalComponent
        closeButtonRequired={false}
        open={openModal}
        // title={"Pincode Not Serviceable"}
        handleModal={setOpenModal}
      >
        {modalContent()}
      </ModalComponent>
    </>
  );
};

export default PincodeValidation;
